import React from 'react';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Support',
      links: ['Help centre', 'Contact us', 'Cancellation options', 'Safety resource centre'],
    },
    {
      title: 'Discover',
      links: ['Trending destinations', 'Travel articles', 'Seasonal deals', 'Gift cards'],
    },
    {
      title: 'Terms & settings',
      links: ['Privacy & cookies', 'Terms & conditions', 'Dispute resolution', 'Modern slavery statement'],
    },
    {
      title: 'Partners',
      links: ['List your property', 'Become an affiliate', 'For business', 'Travel agents'],
    },
    {
      title: 'About',
      links: ['About Ammy Services', 'Careers', 'Sustainability', 'Press centre'],
    },
  ];

  return (
    <footer>
      <div className="container">
        <div className="foot-grid">
          {footerLinks.map((col, idx) => (
            <div key={idx} className="foot-col">
              <h5>{col.title}</h5>
              {col.links.map((link, linkIdx) => (
                <button
                  key={linkIdx}
                  onClick={() => {}}
                  style={{ background: 'none', padding: 0, cursor: 'pointer', textAlign: 'left' }}
                  className="foot-link"
                >
                  {link}
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="foot-bottom container">
        © {year} Ammy Services. All rights reserved. Built for travellers in India.
      </div>
    </footer>
  );
}
